import { z } from 'zod';
import { PaginationMeta, PaginationMetaSchema } from '@/types/pagination-meta.ts';
import { UserSchema } from '@/types/user/user.type.ts';
import { UserStatus } from '@/types/user/user-status.type.ts';

export type UsersPaginatorItem = {
    id: number,
    dealer_id: number | null,
    dealer_name: string | null,
    email: string,
    full_name: string,
    status: string,
    is_admin: boolean,
};

export type UsersPaginator = {
    data: UsersPaginatorItem[],
    meta: PaginationMeta,
};

export type UsersRequestFilter = {
    dealer_id?: number[],
    email?: string,
    status?: UserStatus[],
    is_admin?: 0 | 1,
    page?: number,
    limit?: number,
    sort: Record<string, string>[],
};

const UsersPaginatorItemSchema = z.object({
    id: z.number(),
    dealer_id: z.number().nullable(),
    dealer_name: z.string().nullable(),
    email: z.string(),
    full_name: z.string(),
    status: z.string(),
    is_admin: z.boolean(),
});

export const UsersSchema = z.array(UserSchema);

export const UsersPaginatorSchema = z.object({
    data: z.array(UsersPaginatorItemSchema),
    meta: PaginationMetaSchema,
});

export type CurrentUser = {
    id: number,
    dealer_id?: number,
    dealer_name?: string,
    dealer_sap_code?: string,
    email: string,
    full_name: string,
    phone?: string,
    status: string,
    is_admin: boolean,
    is_certified_dealer: boolean,
    dealer_city_name?: string | null,
    holding_name?: string | null,
};

export const CurrentUserSchema = z.object({
    id: z.number(),
    dealer_id: z.number().nullable(),
    dealer_name: z.string().nullable(),
    dealer_sap_code: z.string().nullable(),
    email: z.string(),
    full_name: z.string(),
    phone: z.string().nullable(),
    status: z.string(),
    is_admin: z.boolean(),
    is_certified_dealer: z.boolean().optional(),
    dealer_city_name: z.string().nullable().optional(),
    holding_name: z.string().nullable().optional(),
});
